//Appends image to The Science Grid
$(document).ready(function() {
    // Create an image element
    const img = $('<img>', { 
        src: 'https://cdn.shopify.com/s/files/1/0904/6668/1171/files/dnagraphic.gif?v=1732311630', // Replace with your image path
        alt: 'Description of the image', // Optional alt attribute
        class: 'dna-img' // Add the class
    });

    // Append the image to the specific div
    $('.custom-block-container').append(img);
});